import React from 'react'
import { connect } from 'react-redux'
import { CollabConnectionProvider } from '@slite/editor'
import scrollIntoView from 'scroll-into-view'

import { selectors as ConfigSelectors } from 'data/config'
import { actions as UIActions } from 'data/ui'
import { actions as PublicUIActions } from 'data/publicUI'

import { Editor as PublicNoteEditor } from 'screens/PublicNotesShow'
import { NoteTitle, ChannelNoteLayout } from 'components/Public/Layout'
import * as Icons from 'components/Utils/Icons'

const TITLE_ID = 'note-title'

class NotePanel extends React.Component {
  componentDidUpdate(prevProps) {
    const { note } = this.props
    const { note: previousNote } = prevProps
    if (
      (!previousNote && note) ||
      (previousNote && note && previousNote.get('id') !== note.get('id'))
    ) {
      scrollIntoView(document.getElementById(TITLE_ID), { time: 0 })
    }
  }
  render() {
    const { note, publicChannelId } = this.props
    const collabProviderProps = {
      collabEndpoint: this.props.collabEndpoint,
      onConnectionChange: this.props.onConnectionChange,
    }

    const noteHasLoaded = Boolean(note)
    const noteTitle = (note && note.get('title')) || 'Untitled'

    return (
      <ChannelNoteLayout>
        <div
          className="public-channel-back-to-control flexbox flexbox-align-center pointer font-weight-medium padding-vertical-medium shade-20"
          onClick={this.props.resetActiveNote}
        >
          <Icons.ArrowLeftIcon size={12} className="margin-right-smaller" />
          <div>Return to menu</div>
        </div>
        {noteHasLoaded && (
          <div id={TITLE_ID}>
            <NoteTitle>{noteTitle}</NoteTitle>
          </div>
        )}
        <CollabConnectionProvider {...collabProviderProps}>
          {noteHasLoaded && (
            <PublicNoteEditor
              noteId={noteHasLoaded ? note.get('id') : null}
              publicChannelId={publicChannelId}
              isEditable={false}
            />
          )}
        </CollabConnectionProvider>
      </ChannelNoteLayout>
    )
  }
}

export default connect(
  state => ({
    collabEndpoint: ConfigSelectors.getCollabEndpoint(state),
  }),

  dispatch => ({
    resetActiveNote: () => dispatch(PublicUIActions.setActiveNoteId(null)),
    onConnectionChange: status => {
      dispatch(UIActions.setConnectionStatus({ service: 'collab', status }))
    },
  })
)(NotePanel)
